/**
 * @description 郵便番号から住所を検索する。
 * @export
 * @param {int} postalCode 郵便番号
 * @param {string} [pref='pref_id'] 都道府県ID
 * @param {string} [address='address'] 市区町村
 */
export default function applyAddress(postalCode, pref = 'pref_id', address = 'address') {
  new YubinBango.Core(postalCode, addr => {
    document.getElementsByName(pref)[0].value = addr.region_id;
    document.getElementsByName(address)[0].value = addr.locality + addr.street;
  });
}
